const errorMsg = {
    required: "この項目は必須です。",
    dobError: "未来の年月でご登録いただけません。再度生年月をご指定ください。",
    lengthError: "パスワード（半角英数字8字以上）",
    emailError: "正しいメールアドレスを入力してください。",
    pwdError: "パスワード（半角英数字8字以上）",
    nameJPError: "漢字または、かなを入力してください。",
    kanaError: "カタカナを入力してください。",
    postalCodeError: "該当する住所が見つかりません。郵便番号を再度ご確認ください。",
    phoneError: "正しい電話番号を入力して下さい。",
    requiredAdditionalInfo: "未入力の項目をご入力お願いいたします。",
    technicalError: "現在、技術的な問題が発生しています。後でもう一度お試しください。",
    "INVALID OUTLET": "店舗のQRコードが正しくありません",
}

function showLoader() {
    document.querySelector('.levi-global-loader').style.display = 'block';
}

function hideLoader() {
    document.querySelector('.levi-global-loader').style.display = 'none';
}

const setStoreId = (params) => {
    if (params.get("storeId")) {
        return;
    }
    const storeId = localStorage.getItem('storeId');
    const storeName = localStorage.getItem('storeName');
    if (storeId) {
        params.set('storeId', storeId);
        params.set('storeName', storeName);
    }
}

const clearStoreId = () => {
    localStorage.removeItem('storeId');
    localStorage.removeItem('storeName');
}

document.addEventListener('DOMContentLoaded', () => {
    let action = 'register';
    let submitBtn = document.querySelector('.register-form__wrapper .register-submit');
    const params = new URL(window.location.href).searchParams;
    setStoreId(params);
    const noPasswordRequire = ['update', 'terms'].includes(params.get("action")) || params.get("shopifyCustomerId");
    const errorPanel = document.querySelector("#register-error");

    if (window.location.search) {
        // when scan QR code it include storeId and storeName
        if (!params.get("checkout_url") && !(params.get("storeId") && params.size === 2)) {
            if (params.get("action")) {
                action = params.get("action");
            }

            const pageTitle = document.querySelector('.customer.register > h1');
            pageTitle.innerHTML = '新規会員登録・登録情報更新';
            submitBtn.innerHTML = '登録・更新';

            errorPanel.innerHTML = errorMsg?.requiredAdditionalInfo;
            errorPanel.style.display = "block";

            const formElements = {
                email: { selector: "#RegisterForm-email", defaultValue: '' },
                gender: { selector: "#RegisterForm-Sex", defaultValue: 'Male', customSelect: true },
                emailOptIn: { selector: "#dwfrm_profile_customer_addtoemaillist", isCheckbox: true },
                postOptIn: { selector: "#dwfrm_profile_customer_postalMail", isCheckbox: true },
                phone: { selector: "#RegisterForm-Telephone", defaultValue: '' },
                firstName: { selector: "#RegisterForm-FirstName", defaultValue: '' },
                lastName: { selector: "#RegisterForm-LastName", defaultValue: '' },
                firstNameKana: { selector: "#RegisterForm-FirstNameHira", defaultValue: '' },
                lastNameKana: { selector: "#RegisterForm-LastNameKata", defaultValue: '' },
                password: { selector: "#RegisterForm-password", defaultValue: '' },
                prefecture: { selector: "#RegisterForm-Prefectures", defaultValue: '', customSelect: true },
                city: { selector: "#RegisterForm-Municipalities", defaultValue: '' },
                address1: { selector: "#RegisterForm-TownArea", defaultValue: '' },
                address2: { selector: "#RegisterForm-Building", defaultValue: '' },
                postalCode: { selector: "#RegisterForm-Address", defaultValue: '' },
                tnc: { selector: "#dwfrm_profile_customer_termsandconditions", isCheckbox: true },
            };

            Object.entries(formElements).forEach(([param, config]) => {
                const element = document.querySelector(config.selector);
                if (!element) return;

                if (config.isCheckbox) {
                    element.checked = params.get(param) === "true";
                } else if (config.customSelect) {
                    const value = params.get(param);
                    if (typeof value !== 'undefined' && value !== null && value !== '') {
                        element.value = value;
                    } else {
                        element.value = config.defaultValue;
                    }
                    element.dispatchEvent(new Event('change'));
                } else {
                    const value = params.get(param)
                    if (value && value !== 'null' && value !== 'undefined') {
                        element.value = value;
                    } else {
                        element.value = config.defaultValue;
                    }
                }

                const dob = params.get("dob");
                if (dob) {
                    const dobYear = dob.split("-")[0];
                    const dobMonth = dob.split("-")[1];
                    const dobYearElement = document.querySelector("#RegisterForm-dob-year");
                    const dobMonthElement = document.querySelector("#RegisterForm-dob-month");

                    dobYearElement.value = dobYear;
                    dobMonthElement.value = dobMonth;
                    dobYearElement.dispatchEvent(new Event('change'));
                    dobMonthElement.dispatchEvent(new Event('change'));
                }
            });
        }
    }

    // Remove password field if action is update or terms
    if (noPasswordRequire) {
        const passwordField = document.querySelector('#RegisterForm-password').closest('.form-field');
        const passwordLabel = passwordField.querySelector('label');
        const passwordInput = document.querySelector('#RegisterForm-password');
        passwordLabel.remove();
        passwordInput.remove();

        document.querySelector("#RegisterForm-email");
        const emailField = document.querySelector("#RegisterForm-email");
        if (emailField) {
            emailField.readOnly = true;
        }

        // const dobYearElement = document.querySelector("#RegisterForm-dob-year");
        // const dobCustomSelect = dobYearElement.closest('custom-select');
        // dobCustomSelect.setReadOnly(true);

        // const dobMonthElement = document.querySelector("#RegisterForm-dob-month");
        // const dobMonthCustomSelect = dobMonthElement.closest('custom-select');
        // dobMonthCustomSelect.setReadOnly(true);
    }

    handleChanges();

    if (submitBtn) {
        submitBtn.addEventListener('click', async () => {
            let canSubmit = true;

            if (canSubmit) canSubmit = requiredValidation();
            if (canSubmit) canSubmit = emailValidation();
            if (canSubmit) canSubmit = dobValidation();
            if (canSubmit && !noPasswordRequire) canSubmit = passwordValidation();
            if (canSubmit) canSubmit = lastNameValidation();
            if (canSubmit) canSubmit = firstNameValidation();
            if (canSubmit) canSubmit = katakanaLastValidation();
            if (canSubmit) canSubmit = katakanaFirstValidation();
            if (canSubmit) canSubmit = postalCodeValidation();
            if (canSubmit) canSubmit = phoneValidation();

            if (canSubmit) {
                showLoader();

                const token = new Date().getTime();
                const email = document.querySelector("#RegisterForm-email").value;
                const firstName = document.querySelector("#RegisterForm-FirstName").value;
                const lastName = document.querySelector("#RegisterForm-LastName").value;
                const firstNameKana = document.querySelector("#RegisterForm-FirstNameHira").value;
                const lastNameKana = document.querySelector("#RegisterForm-LastNameKata").value;
                const password = document.querySelector("#RegisterForm-password")?.value;
                const gender = document.querySelector("#RegisterForm-Sex").value;
                const emailOptIn = document.querySelector("#dwfrm_profile_customer_addtoemaillist").checked;
                const postOptIn = document.querySelector("#dwfrm_profile_customer_postalMail").checked;
                const tnc = document.querySelector("#dwfrm_profile_customer_termsandconditions").checked;
                const phone = document.querySelector("#RegisterForm-Telephone").value.toString();
                const formattedPhone = phone.replace(/^0+/, ''); // Remove leading zeros
                const dob = document.querySelector("#RegisterForm-dob-year").value + "-" + document.querySelector("#RegisterForm-dob-month").value;
                const province = document.querySelector("#RegisterForm-Prefectures").value
                const city = document.querySelector("#RegisterForm-Municipalities").value;
                const zip = document.querySelector("#RegisterForm-Address").value;
                const address1 = document.querySelector("#RegisterForm-TownArea").value;
                const address2 = document.querySelector("#RegisterForm-Building").value;
                const formattedZip = zip.length > 0 ? (zip.match(/^\d{3}-\d{4}$/) ? zip : `${zip.slice(0, 3)}-${zip.slice(3)}`) : '';
                const cc = params.get("cc");

                if (window.location.search == "") {
                    const params = new URL(window.location.href).searchParams;
                    setStoreId(params);
                    const formData = {
                        token: token,
                        firstName: firstName,
                        lastName: lastName,
                        firstNameKana: firstNameKana,
                        lastNameKana: lastNameKana,
                        email: email,
                        password: password,
                        confirmPassword: password,
                        dob: dob,
                        gender: gender,
                        emailOptIn: emailOptIn,
                        postOptIn: postOptIn,
                        smsOptIn: false,
                        postalCode: formattedZip,
                        zip: formattedZip,
                        province: province,
                        city: city,
                        address1: address1,
                        address2: address2,
                        interestIn: gender,
                        tnc: tnc,
                        phone: formattedPhone,
                        returnUrl: params.get("checkout_url") === "guest" ? `${window.shopUrl}/checkout` : `${window.shopUrl}/account`,
                        cc: cc || undefined
                    };

                    formData.posSource = params.get("storeId") || "Portal";
                    // Google reCaptcha
                    // grecaptcha.ready(function () {
                    //     grecaptcha.execute(window.google_captcha_key, { action: 'submit' }).then(function (token) {
                    //         getRecaptchaScore(token).then(async function (recaptchaData) {
                    //             if (!recaptchaData.success) {
                    //                 errorPanel.innerHTML = errorMsg?.technicalError;
                    //                 errorPanel.style.display = "block";
                    //                 window.scrollTo({
                    //                     top: 0,
                    //                     behavior: 'smooth'
                    //                 })
                    //                 return;
                    //             }

                    //             const validationResult = validateLoginAttempt(recaptchaData.score, 'register');

                    //             if (!validationResult.allowed && validationResult.redirect) {
                    //                 window.location.href = validationResult.dns;
                    //             }

                    //             if (!validationResult.allowed) {
                    //                 let blockTime = Number(validationResult.blockDuration);
                    //                 if (isNaN(blockTime)) {
                    //                     blockTime = RECAPTCHA_CONFIG.BLOCK_TIMES.SECOND;
                    //                 }
                    //                 errorPanel.innerHTML = `不審な動きが検出されました。${blockTime / 60000}分後に再度お試しください。`;
                    //                 errorPanel.style.display = "block";
                    //                 window.scrollTo({
                    //                     top: 0,
                    //                     behavior: 'smooth'
                    //                 })
                    //                 return;
                    //             }

                                const response = await fetch(`${window.levis_api_app_proxy}/shopify-proxy-auth/register-direct`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(formData),
                                });
                                const responseJson = await response.json();
                                const data = responseJson.data;
                                console.log("responseData", data);

                                if (response.ok) { // checks if the response status is 200-299
                                    sendAppsflyerEvent('complete_registration', { registration_method: 'app' });
                                    if (typeof data.rewardTriggered === 'boolean') {
                                        localStorage.setItem(
                                            'rewardStatus',
                                            data.rewardTriggered ? 'success' : 'failed'
                                        );
                                    }
                                    clearStoreId();
                                    if (data?.nextflow === 'redirect') {
                                        window.location.href = data?.url;
                                    } else {
                                        console.log("nextflow is not 'redirect'. Data:", data);
                                    }
                                } else {
                                    let errorMessage = responseJson?.message
                                    if (responseJson?.errors) {
                                        errorMessage = responseJson?.errors[0]?.constraints[0]?.message;
                                    }
                                    const mappedErrorMessage = errorMsg[errorMessage] || errorMessage;
                                    errorPanel.innerHTML = mappedErrorMessage;
                                    errorPanel.style.display = "block";
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    })
                                }
                                hideLoader();
                    //         })
                    //     })
                    // });
                } else {
                    const params = new URL(window.location.href).searchParams;
                    setStoreId(params);
                    let formData = {
                        token: params.get("token") ?? token,
                        firstName: firstName,
                        lastName: lastName,
                        firstNameKana: firstNameKana,
                        lastNameKana: lastNameKana,
                        email: email,
                        password: password,
                        confirmPassword: password,
                        dob: dob,
                        gender: gender,
                        emailOptIn: emailOptIn,
                        postOptIn: postOptIn,
                        smsOptIn: false,
                        membershipId: params.get("membershipId") ?? '',
                        zip: formattedZip,
                        province: province,
                        city: city,
                        address1: address1,
                        address2: address2,
                        interestIn: gender,
                        tnc: tnc,
                        phone: formattedPhone,
                        returnUrl: params.get("checkout_url") === "guest" ? `${window.shopUrl}/checkout` : `${window.shopUrl}/account`,
                        cc: params.get("cc") || undefined
                    };
                    const multipassIdentifier = params.get("multipassIdentifier");
                    if (multipassIdentifier) {
                        formData.multipassIdentifier = multipassIdentifier;
                    }
                    formData.posSource = params.get("storeId") || "Portal";

                    let actionType = 'register-direct';
                    if (['terms', 'update'].includes(action)) {
                        actionType = action;
                        delete formData.password;
                    }

                    // Google captcha
                    // grecaptcha.ready(function () {
                    //     grecaptcha.execute(window.google_captcha_key, { action: 'submit' }).then(function (token) {
                    //         getRecaptchaScore(token).then(async function (recaptchaData) {
                    //             if (!recaptchaData.success) {
                    //                 errorPanel.innerHTML = errorMsg?.technicalError;
                    //                 errorPanel.style.display = "block";
                    //                 window.scrollTo({
                    //                     top: 0,
                    //                     behavior: 'smooth'
                    //                 })
                    //                 return;
                    //             }

                    //             const validationResult = validateLoginAttempt(recaptchaData.score, 'register');

                    //             if (!validationResult.allowed && validationResult.redirect) {
                    //                 window.location.href = validationResult.dns;
                    //             }

                    //             if (!validationResult.allowed) {
                    //                 let blockTime = Number(validationResult.blockDuration);
                    //                 if (isNaN(blockTime)) {
                    //                     blockTime = RECAPTCHA_CONFIG.BLOCK_TIMES.SECOND;
                    //                 }
                    //                 errorPanel.innerHTML = `不審な動きが検出されました。${blockTime / 60000}分後に再度お試しください。`;
                    //                 errorPanel.style.display = "block";
                    //                 window.scrollTo({
                    //                     top: 0,
                    //                     behavior: 'smooth'
                    //                 })
                    //                 return;
                    //             }

                                const response = await fetch(`${window.levis_api_app_proxy}/shopify-proxy-auth/${actionType}`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(formData),
                                });
                                const responseJson = await response.json();
                                const data = responseJson.data;

                                if (response.ok) { // checks if the response status is 200-299
                                    sendAppsflyerEvent('complete_registration', { registration_method: 'app' });                                  
                                    clearStoreId();
                                    window.location.href = data?.url;
                                } else {
                                    let errorMessage = responseJson?.message
                                    if (responseJson?.errors) {
                                        errorMessage = responseJson?.errors[0]?.constraints[0]?.message;
                                    }
                                    const mappedErrorMessage = errorMsg[errorMessage] || errorMessage;
                                    errorPanel.innerHTML = mappedErrorMessage;
                                    errorPanel.style.display = "block";
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    })
                                }
                                hideLoader();
                    //         })
                    //     })
                    // });
                }
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
        });
    }
})

//handle changes
function handleChanges() {
    const inputs = document.querySelectorAll('.register-form__wrapper .form-input.required');
    const selects = document.querySelectorAll('.register-form__wrapper .form-select.required');
    const termsCheckbox = document.querySelector('.register-form__wrapper .input-checkbox');

    if (inputs.length > 0) {
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                if (input.value) {
                    input.closest('.form-field').classList.remove('error');
                } else {
                    input.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
                    input.closest('.form-field').classList.add('error');
                }
            })
        })
    }

    if (selects.length > 0) {
        selects.forEach(select => {
            select.addEventListener('change', () => {
                if (select.value) {
                    select.closest('.form-field').classList.remove('error');
                } else {
                    select.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
                    select.closest('.form-field').classList.add('error');
                }
            })
        })
    }

    if (termsCheckbox) {
        termsCheckbox.addEventListener('change', () => {
            if (termsCheckbox.checked) {
                termsCheckbox.closest('.form-field').classList.remove('error');
            } else {
                termsCheckbox.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
                termsCheckbox.closest('.form-field').classList.add('error');
            }
        })
    }
}

// required fields validation
function requiredValidation() {
    let inputs = document.querySelectorAll('.register-form__wrapper .form-input.required');
    let genderSelect = document.querySelector('#RegisterForm-Sex');
    let dobSelect = document.querySelector('#RegisterForm-dob');
    let termsCheckbox = document.querySelector('.register-form__wrapper .input-checkbox');

    let canSubmit = true;

    if (inputs.length > 0) {
        inputs.forEach(input => {
            if (input.value == '') {
                input.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
                input.closest('.form-field').classList.add('error');
                canSubmit = false;
            } else {
                input.closest('.form-field').classList.remove('error');
            }
        })
    }

    if (dobSelect) {
        let isValue = true;

        let selects = [
            document.querySelector('#RegisterForm-dob-month'),
            document.querySelector('#RegisterForm-dob-year')
        ]

        if (selects.length) {
            selects.forEach(select => {
                if (select.value == '') isValue = false;
            })
        }

        if (!isValue) {
            dobSelect.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
            dobSelect.closest('.form-field').classList.add('error');
            canSubmit = false;
        } else {
            dobSelect.closest('.form-field').classList.remove('error');
        }
    }

    if (genderSelect) {
        if (genderSelect.value == '') {
            genderSelect.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
            genderSelect.closest('.form-field').classList.add('error');
            canSubmit = false;
        } else {
            genderSelect.closest('.form-field').classList.remove('error');
        }
    }

    if (termsCheckbox) {
        if (!termsCheckbox.checked) {
            termsCheckbox.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.required;
            termsCheckbox.closest('.form-field').classList.add('error');
            canSubmit = false;
        } else {
            termsCheckbox.closest('.form-field').classList.remove('error');
        }
    }

    return canSubmit;
}

// email validation
function emailValidation() {
    const emailInput = document.querySelector("#RegisterForm-email");
    const emailRegex = window?.regex?.email;

    if (!emailRegex.test(emailInput.value)) {
        emailInput.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.emailError;
        emailInput.closest('.form-field').classList.add('error');
        return false;
    } else {
        emailInput.closest('.form-field').classList.remove('error');
        return true;
    }
}

// check if dob is further date or not
function dobValidation() {
    const currentDate = new Date();
    const currentTime = currentDate.getTime();

    const dob = document.querySelector("#RegisterForm-dob-year").value + "-" + document.querySelector("#RegisterForm-dob-month").value;
    const dobDate = new Date(dob);
    const dobTime = dobDate.getTime();

    if (dobTime > currentTime) {
        document.querySelector("#RegisterForm-dob-year").closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.dobError;
        document.querySelector("#RegisterForm-dob-year").closest('.form-field').classList.add('error');
        return false;
    } else {
        document.querySelector("#RegisterForm-dob-year").closest('.form-field').classList.remove('error');
        return true;
    }
}

// password validation
function passwordValidation() {
    const pwdInput = document.querySelector("#RegisterForm-password");
    const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+={}\[\]:;"'<>,.?/~`-]{8,}$/;

    if (!regex.test(pwdInput.value)) {
        pwdInput.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.pwdError;
        pwdInput.closest('.form-field').classList.add('error');
        return false;
    } else {
        pwdInput.closest('.form-field').classList.remove('error');
        return true;
    }
}

// first name validation
// function firstNameValidation() {
//     const firstName = document.querySelector("#RegisterForm-FirstName");
//     const regex = /^[A-Za-z\u3040-\u309f\u30a0-\u30ff\u4e00-\u9faf\u3400-\u4dbf々ヶヵ]+$/;

//     if (!regex.test(firstName.value)) {
//         firstName.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.nameJPError;
//         firstName.closest('.form-field').classList.add('error');
//         return false;
//     } else {
//         firstName.closest('.form-field').classList.remove('error');
//         return true;
//     }
// }

// last name validation
// function lastNameValidation() {
//     const lastName = document.querySelector("#RegisterForm-LastName");
//     const regex = /^[A-Za-z\u3040-\u309f\u30a0-\u30ff\u4e00-\u9faf\u3400-\u4dbf々ヶヵ]+$/;

//     if (!regex.test(lastName.value)) {
//         lastName.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.nameJPError;
//         lastName.closest('.form-field').classList.add('error');
//         return false;
//     } else {
//         lastName.closest('.form-field').classList.remove('error');
//         return true;
//     }
// }

// First name validation
const firstNameInput = document.querySelector("#RegisterForm-FirstName");

// Katakana regex to remove all Katakana except ヶ, ヵ
const katakanaRegex = /[\u30A0-\u30FF\uFF66-\uFF9F]/gu;

// Allowed characters: A–Z a–z, Hiragana, Kanji, 々, ヶ, ヵ
// const allowedRegex = /^[A-Za-z\u3040-\u309F\u4E00-\u9FFF\u3400-\u4DBF々ヶヵ]+$/u;
const allowedRegex = /^[\u3040-\u309F\u4E00-\u9FFF\u3400-\u4DBF々ヶヵ]+$/u;

// Sanitize input: removes disallowed characters and unwanted Katakana
function sanitizeInputValue(value) {
    return value
        .replace(katakanaRegex, (ch) => (ch === "ヶ" || ch === "ヵ" ? ch : "")) // keep only ヶ and ヵ
        .replace(/[^\u3040-\u309F\u4E00-\u9FFF\u3400-\u4DBF々ヶヵ]/gu, "");
}


// Block disallowed characters while typing
function blockDisallowedInput(e) {
    if (e.inputType && e.inputType.startsWith("insertComposition")) return; // skip IME
    // const input = e.data;
    // if (!input) return;
    // if (!allowedRegex.test(input)) {
    //     e.preventDefault();
    // }
    const input = e.data ?? "";
 if (!input) return;

// Test *each character in input*
 for (const char of input) {
    if (!/^[\u3040-\u309F\u4E00-\u9FFF\u3400-\u4DBF々ヶヵ]$/u.test(char)) {
        e.preventDefault();
        return;
    }
}
}

// Validate field (first name)
function validateField(input) {
    const original = input.value;
    const sanitized = sanitizeInputValue(original);

    if (sanitized !== original) {
        const pos = input.selectionStart;
        input.value = sanitized;
        input.setSelectionRange(pos, pos);
    }

    const field = input.closest(".form-field");
    const message = field?.querySelector(".form__message");

    if (!input.value || !allowedRegex.test(input.value)) {
        message.innerHTML = errorMsg?.nameJPError || "Invalid input.";
        field.classList.add("error");
        return false;
    } else {
        message.innerHTML = "";
        field.classList.remove("error");
        return true;
    }
}

function firstNameValidation() {
    return validateField(firstNameInput);
}

// Event listeners
if (firstNameInput) {
    firstNameInput.addEventListener("compositionstart", () => firstNameInput.isComposing = true);
    firstNameInput.addEventListener("compositionupdate", () => {
        const field = firstNameInput.closest(".form-field");
        const message = field?.querySelector(".form__message");
        message.innerHTML = "";
    });
    firstNameInput.addEventListener("compositionend", () => {
        firstNameInput.isComposing = false;
        validateField(firstNameInput);
    });
    firstNameInput.addEventListener("beforeinput", blockDisallowedInput);
    // firstNameInput.addEventListener("input", () => {
    //     if (!firstNameInput.isComposing) validateField(firstNameInput);
    // });
    firstNameInput.addEventListener("input", () => {
    if (firstNameInput.isComposing) return;
    
    const sanitized = sanitizeInputValue(firstNameInput.value);
    if (sanitized !== firstNameInput.value) {
        firstNameInput.value = sanitized;
    }
    validateField(firstNameInput);
});

    firstNameInput.addEventListener("paste", (e) => {
        const pasted = (e.clipboardData || window.clipboardData).getData("text") || "";
        const sanitized = sanitizeInputValue(pasted);
        if (sanitized !== pasted) {
            e.preventDefault();
            const start = firstNameInput.selectionStart;
            const end = firstNameInput.selectionEnd;
            firstNameInput.value = firstNameInput.value.slice(0, start) + sanitized + firstNameInput.value.slice(end);
            firstNameInput.setSelectionRange(start + sanitized.length, start + sanitized.length);
            validateField(firstNameInput);
        }
    });
}

// Last name validation
const lastNameInput = document.querySelector("#RegisterForm-LastName");

// Sanitize input: removes disallowed characters and unwanted Katakana
function sanitizeLastNameValue(value) {
    return value
        .replace(katakanaRegex, (ch) => (ch === "ヶ" || ch === "ヵ" ? ch : ""))
        .replace(/[^\u3040-\u309F\u4E00-\u9FFF\u3400-\u4DBF々ヶヵ]/gu, "");
}

// Validate last name
function validateLastNameField(input) {
    const original = input.value;
    const sanitized = sanitizeLastNameValue(original);

    if (sanitized !== original) {
        const pos = input.selectionStart;
        input.value = sanitized;
        input.setSelectionRange(pos, pos);
    }

    const field = input.closest(".form-field");
    const message = field?.querySelector(".form__message");

    if (!input.value || !allowedRegex.test(input.value)) {
        message.innerHTML = errorMsg?.nameJPError || "Invalid input.";
        field.classList.add("error");
        return false;
    } else {
        message.innerHTML = "";
        field.classList.remove("error");
        return true;
    }
}

function lastNameValidation() {
    return validateLastNameField(lastNameInput);
}

// Event listeners
if (lastNameInput) {
    lastNameInput.addEventListener("compositionstart", () => lastNameInput.isComposing = true);
    lastNameInput.addEventListener("compositionupdate", () => {
        const field = lastNameInput.closest(".form-field");
        const message = field?.querySelector(".form__message");
        message.innerHTML = "";
    });
    lastNameInput.addEventListener("compositionend", () => {
        lastNameInput.isComposing = false;
        validateLastNameField(lastNameInput);
    });
    lastNameInput.addEventListener("beforeinput", blockDisallowedInput);
    // lastNameInput.addEventListener("input", () => {
    //     if (!lastNameInput.isComposing) validateLastNameField(lastNameInput);
    // });
    lastNameInput.addEventListener("input", () => {
    if (lastNameInput.isComposing) return;

    const sanitized = sanitizeLastNameValue(lastNameInput.value);

    // Clean unwanted characters if Safari allows them
    if (sanitized !== lastNameInput.value) {
        lastNameInput.value = sanitized;
    }

    validateLastNameField(lastNameInput);
});

    lastNameInput.addEventListener("paste", (e) => {
        const pasted = (e.clipboardData || window.clipboardData).getData("text") || "";
        const sanitized = sanitizeLastNameValue(pasted);
        if (sanitized !== pasted) {
            e.preventDefault();
            const start = lastNameInput.selectionStart;
            const end = lastNameInput.selectionEnd;
            lastNameInput.value = lastNameInput.value.slice(0, start) + sanitized + lastNameInput.value.slice(end);
            lastNameInput.setSelectionRange(start + sanitized.length, start + sanitized.length);
            validateLastNameField(lastNameInput);
        }
    });
}

// katakana first name validation
// function katakanaFirstValidation() {
//     const firstNameKana = document.querySelector("#RegisterForm-FirstNameHira");
//     const kanaRegex = /^[\u3040-\u309f\u30a0-\u30ff]+$/;

//     if (!kanaRegex.test(firstNameKana.value)) {
//         firstNameKana.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.kanaError;
//         firstNameKana.closest('.form-field').classList.add('error');
//         return false;
//     } else {
//         firstNameKana.closest('.form-field').classList.remove('error');
//         return true;
//     }
// }


// katakana last name validation
// function katakanaLastValidation() {
//     const lastNameKana = document.querySelector("#RegisterForm-LastNameKata");
//     const kanaRegex = /^[\u3040-\u309f\u30a0-\u30ff]+$/;

//     if (!kanaRegex.test(lastNameKana.value)) {
//         lastNameKana.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.kanaError;
//         lastNameKana.closest('.form-field').classList.add('error');
//         return false;
//     } else {
//         lastNameKana.closest('.form-field').classList.remove('error');
//         return true;
//     }
// }

//Katakana vaidation firstname

// Allow only full-width Katakana + iteration marks + small kana + long vowel mark
const allowedKatakanaRegex = /^[\u30A0-\u30FFー々ヵヶ]+$/u;
const disallowedKatakanaRegex = /[^\u30A0-\u30FFー々ヵヶ]/gu;
const halfWidthKatakanaRegex = /[\uFF65-\uFF9F]/gu;

// Sanitize: remove any disallowed or half-width Katakana
function sanitizeKatakanaValue(value) {
  return value.replace(disallowedKatakanaRegex, "").replace(halfWidthKatakanaRegex, "");
}

// Validation function
function katakanaFirstValidation() {
  const input = document.querySelector("#RegisterForm-FirstNameHira");
  if (!input) return true;

  input.value = sanitizeKatakanaValue(input.value);
  const value = input.value.trim();

  const field = input.closest(".form-field");
  const message = field.querySelector(".form__message");

  if (!value || !allowedKatakanaRegex.test(value)) {
    message.innerHTML = errorMsg?.kanaError || "Please enter valid full-width Katakana.";
    field.classList.add("error");
    return false;
  } else {
    message.innerHTML = "";
    field.classList.remove("error");
    return true;
  }
}

// IME-safe event bindings
const firstNameKanaInput = document.querySelector("#RegisterForm-FirstNameHira");
if (firstNameKanaInput) {
  let isComposing = false;

  firstNameKanaInput.addEventListener("compositionstart", () => {
    isComposing = true;
  });

  firstNameKanaInput.addEventListener("compositionend", () => {
    isComposing = false;
    setTimeout(katakanaFirstValidation, 0); // validate after IME commit
  });

  firstNameKanaInput.addEventListener("input", () => {
    if (!isComposing) katakanaFirstValidation();
  });

  firstNameKanaInput.addEventListener("paste", (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    const sanitized = sanitizeKatakanaValue(pasted);
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    e.target.value = e.target.value.slice(0, start) + sanitized + e.target.value.slice(end);
    e.target.setSelectionRange(start + sanitized.length, start + sanitized.length);
    katakanaFirstValidation();
  });
}

//katakana lastname validation
function katakanaLastValidation() {
  const input = document.querySelector("#RegisterForm-LastNameKata");
  if (!input) return true;

  input.value = sanitizeKatakanaValue(input.value);
  const value = input.value.trim();

  const field = input.closest(".form-field");
  const message = field.querySelector(".form__message");

  if (!value || !allowedKatakanaRegex.test(value)) {
    message.innerHTML = errorMsg?.kanaError || "Please enter valid full-width Katakana.";
    field.classList.add("error");
    return false;
  } else {
    message.innerHTML = "";
    field.classList.remove("error");
    return true;
  }
}

// IME-safe event bindings
const lastNameKanaInput = document.querySelector("#RegisterForm-LastNameKata");
if (lastNameKanaInput) {
  let isComposing = false;

  lastNameKanaInput.addEventListener("compositionstart", () => {
    isComposing = true;
  });

  lastNameKanaInput.addEventListener("compositionend", () => {
    isComposing = false;
    setTimeout(katakanaLastValidation, 0);
  });

  lastNameKanaInput.addEventListener("input", () => {
    if (!isComposing) katakanaLastValidation();
  });

  lastNameKanaInput.addEventListener("paste", (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    const sanitized = sanitizeKatakanaValue(pasted);
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    e.target.value = e.target.value.slice(0, start) + sanitized + e.target.value.slice(end);
    e.target.setSelectionRange(start + sanitized.length, start + sanitized.length);
    katakanaLastValidation();
  });
}
// postal code validation
// function postalCodeValidation() {
//     const postalCode = document.querySelector("#RegisterForm-Address");
//     const postalCodeRegex = /^\d{3}(-\d{4})?$/;

//     if (postalCode.value) {
//         if (!postalCodeRegex.test(postalCode.value)) {
//             postalCode.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.postalCodeError;
//             postalCode.closest('.form-field').classList.add('error');
//             return false;
//         } else {
//             postalCode.closest('.form-field').classList.remove('error');
//             return true;
//         }
//     } else {
//         return true;
//     }
// }

// Postal code validation
function postalCodeValidation() {
    const postalCode = document.querySelector("#RegisterForm-Address");

    // Remove any emojis or non-digit/hyphen characters immediately
    postalCode.value = postalCode.value.replace(/[^\d-]/g, "");

    // Regex for Japanese postal code: 123-4567 or 1234567
    const postalCodeRegex = /^\d{3}(-?\d{4})?$/;

    if (postalCode.value) {
        if (!postalCodeRegex.test(postalCode.value)) {
            postalCode.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.postalCodeError || "Invalid postal code.";
            postalCode.closest('.form-field').classList.add('error');
            return false;
        } else {
            postalCode.closest('.form-field').classList.remove('error');
            postalCode.closest('.form-field').querySelector('.form__message').innerHTML = "";
            return true;
        }
    } else {
        // Empty field is allowed
        return true;
    }
}

// Optional: Prevent emojis while typing
document.addEventListener("DOMContentLoaded", () => {
    const postalCodeInput = document.querySelector("#RegisterForm-Address");
    if (postalCodeInput) {
        postalCodeInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.replace(/[^\d-]/g, "");
        });
    }
});
// phone validation
// function phoneValidation() {
//     const phone = document.querySelector("#RegisterForm-Telephone");
//     const phoneRegex = /^[0-9]{10,12}$/;

//     if (!phoneRegex.test(phone.value)) {
//         phone.closest('.form-field').querySelector('.form__message').innerHTML = errorMsg?.phoneError;
//         phone.closest('.form-field').classList.add('error');
//         return false;
//     } else {
//         phone.closest('.form-field').classList.remove('error');
//         return true;
//     }
// }

const phoneInput = document.querySelector("#RegisterForm-Telephone");
let isComposing = false;

// ---- Normalize & sanitize input ----
function sanitizePhoneInput(value) {
  return value
    // Convert full-width digits ０-９ → 0-9
    .replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
    // Convert full-width hyphen － → -
    .replace(/－/g, '-')
    // Remove all other characters except 0-9 and hyphen
    .replace(/[^0-9-]/g, '');
}

// ---- Handle IME composition (Japanese typing) ----
phoneInput.addEventListener("compositionstart", () => { isComposing = true; });
phoneInput.addEventListener("compositionend", (e) => {
  isComposing = false;
  phoneInput.value = sanitizePhoneInput(phoneInput.value);
});

// ---- Live input sanitization ----
phoneInput.addEventListener("input", (e) => {
  if (!isComposing) {
    phoneInput.value = sanitizePhoneInput(phoneInput.value);
  }
});

// ---- Phone validation (10-12 digits ignoring hyphens) ----
function phoneValidation() {
  const phone = phoneInput;

  // Sanitize again to be safe
  phone.value = sanitizePhoneInput(phone.value);

  const phoneDigits = phone.value.replace(/-/g, '');
  const phoneRegex = /^[0-9]{10,12}$/;

  const messageEl = phone.closest('.form-field').querySelector('.form__message');

  if (!phoneRegex.test(phoneDigits)) {
    messageEl.innerHTML = errorMsg?.phoneError;
    phone.closest('.form-field').classList.add('error');
    return false;
  } else {
    messageEl.innerHTML = '';
    phone.closest('.form-field').classList.remove('error');
    return true;
  }
}

function sendAppsflyerEvent(event_name, event_value) {
    if (window.navigator.userAgent === 'Yappli') {
        Yappli.sendTrackedEvent(event_name, event_value, function (result, message) {
            if (!result) {
                sendEvent(event_name, event_value);
            }
        })
    }
}
// function removeSpecialChars(input) {
//   input.value = input.value.replace(
//     /[^a-zA-Z0-9\s\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF々ヶヵ-]/g,
//     ''
//   );
// }
// Select the fields
// const municipalityInput = document.querySelector("#RegisterForm-Municipalities");
// const townAreaInput = document.querySelector("#RegisterForm-TownArea");

// Attach input event listeners
// municipalityInput.addEventListener('input', () => removeSpecialChars(municipalityInput));
// townAreaInput.addEventListener('input', () => removeSpecialChars(townAreaInput));

//Town address
function normalizeWidths(str) {
  return str
    // NFKC handles full-width/half-width normalization
    .normalize('NFKC')
    // Optional: normalize hyphen & spaces if needed
    .replace(/－/g, '-') // full-width hyphen → half-width
    .replace(/　/g, ' '); // full-width space → half-width
}

// ---- Allowed characters ----
function isAllowedChar(char) {
  return /[A-Za-z0-9\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF々ヵヶ\s-]/.test(char);
}

// ---- Normalize & sanitize ----
function normalizeAndSanitize(target) {
  let value = normalizeWidths(target.value);
  let filtered = '';
  for (const char of value) {
    if (isAllowedChar(char)) filtered += char;
  }
  if (filtered !== target.value) target.value = filtered;
}

// ---- Attach validation ----
function attachValidation(input) {
  let isComposing = false;
  input.addEventListener('compositionstart', () => { isComposing = true; });
  input.addEventListener('compositionend', (e) => {
    isComposing = false;
    normalizeAndSanitize(e.target);
  });
  input.addEventListener('input', (e) => {
    if (!isComposing) normalizeAndSanitize(e.target);
  });
}

// ---- Attach to fields ----
const municipalityInput = document.querySelector('#RegisterForm-Municipalities');
const townAreaInput = document.querySelector('#RegisterForm-TownArea');

if (municipalityInput) attachValidation(municipalityInput);
if (townAreaInput) attachValidation(townAreaInput);

//Building
// ---- Width Normalization ----
function normalizeWidths(str) {
  return str
    // Convert full-width alphanumeric & symbols → half-width
    .normalize('NFKC')
    // Normalize specific characters explicitly
    .replace(/－/g, '-') // full-width hyphen → half-width
    .replace(/　/g, ' '); // full-width space → half-width
}

// ---- Allowed characters ----
function isAllowedChar(char) {
  // Allow: half-width alphanumeric, Hiragana, full-width Katakana, Kanji,
  // iteration marks (々ヵヶ), spaces, hyphen (-)
  // Block half-width Katakana (\uFF65-\uFF9F)
  return /[A-Za-z0-9\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF々ヵヶ\s-]/.test(char) &&
         !/[\uFF65-\uFF9F]/.test(char);
}

// ---- Normalize & sanitize ----
function normalizeAndSanitize(target) {
  let value = normalizeWidths(target.value);
  let filtered = '';
  for (const char of value) {
    if (isAllowedChar(char)) filtered += char; // skip disallowed characters
  }
  if (filtered !== target.value) target.value = filtered;
}

// ---- Attach validation (IME-safe for Japanese input) ----
function attachBuildingValidation(input) {
  let isComposing = false;

  input.addEventListener('compositionstart', () => { isComposing = true; });

  input.addEventListener('compositionend', (e) => {
    isComposing = false;
    normalizeAndSanitize(e.target);
  });

  input.addEventListener('input', (e) => {
    if (!isComposing) normalizeAndSanitize(e.target);
  });
}

// ---- Attach to Building field only ----
const buildingInput = document.querySelector('#RegisterForm-Building');
if (buildingInput) attachBuildingValidation(buildingInput);


